/**
 * Created by andrey on 30.08.17.
 */

const ColorFulAnimationView = cc.Node.extend({ 
    ctor: function () {
        this._super();

        this.setLocalZOrder(15);

        this.animation = new cleverapps.Spine(bundles.colorful.jsons.colorful_json);
        this.addChild(this.animation);
    },

    animate: function (callback) {
        this.animation.setAnimation(0, "animation", false);
        this.animation.setCompleteListener(() => {
            cleverapps.pool.putInPool(this);
            callback();
        });
    },

    unuse: function () {
        this.removeFromParent(false);
    }
});

ColorFulAnimationView.fillPool = function () {
    if (cleverapps.styles.ColorFulAnimationView.active) {
        for (let i = 0; i < cleverapps.styles.ColorFulAnimationView.animations.number; i++) {
            cleverapps.pool.putInPool(new ColorFulAnimationView());
        }
    }
};

ColorFulAnimationView.factory = function () {
    return cleverapps.pool.hasObject(ColorFulAnimationView) ? cleverapps.pool.getFromPool(ColorFulAnimationView) : undefined;
};

cleverapps.styles.ColorFulAnimationView = {
    active: true,
    animations: {
        number: 3
    }
};
